import JustPay from './JustPay';
export default JustPay;
